<div class="sort-header-container {{ sortOrder }}" [ngClass]="{ 'is-sorted': isSorted }">
	<ng-content></ng-content>
</div>

